<template>
    <div class="form-field form-filex">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <div class="form-file-upload" v-if="uniqueId">
                    <input class="input" type="file" :id="uniqueId" @change="upload($event)">
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {Api} from '../../Api.js'

    export default {
        name: 'Upload',
        props: ['value','width','label'],
        data: function () {
            return {
                internalValue: '',
                img: '',
                uniqueId: null
            }
        },
        created: function() {
            let n = Math.floor(Math.random()*11);
            let k = Math.floor(Math.random()* 1000000);
            this.uniqueId = "file-upload-"+String.fromCharCode(n)+k;

            this.internalValue = this.value;
            this.sizeW = this.width ? this.width : 150;
            //this.get()
        },
        methods: {
            upload(e){
                var fileInput = document.getElementById( this.uniqueId );
                var data = new FormData();
                    data.append( 'file', fileInput.files[0] );

                Api().post('media', data).then((response) => {
                    this.internalValue = response.data[0].id
                    this.img = response.data[0].url
                    this.$emit('input', this.internalValue);
                })
            },
            remove(){
                this.img = null
                this.internalValue = null
                this.$emit('input', this.internalValue);
            },
            get(){
                Api().get('media/'+this.internalValue).then((response) => {
                    this.img = response.data.url
                })
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                this.get()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/FileImport.vue